/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Request parameters for batch retrieving feedback by multiple request IDs.
 */
export type BatchGetFeedbackRequest = {
  /**
   * Array of request IDs (chatcmpl-xxx or resp-xxx) to retrieve feedback for
   */
  ids: Array<string>;
};

/** @internal */
export const BatchGetFeedbackRequest$inboundSchema: z.ZodType<
  BatchGetFeedbackRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  ids: z.array(z.string()),
});
/** @internal */
export type BatchGetFeedbackRequest$Outbound = {
  ids: Array<string>;
};

/** @internal */
export const BatchGetFeedbackRequest$outboundSchema: z.ZodType<
  BatchGetFeedbackRequest$Outbound,
  z.ZodTypeDef,
  BatchGetFeedbackRequest
> = z.object({
  ids: z.array(z.string()),
});

export function batchGetFeedbackRequestToJSON(
  batchGetFeedbackRequest: BatchGetFeedbackRequest,
): string {
  return JSON.stringify(
    BatchGetFeedbackRequest$outboundSchema.parse(batchGetFeedbackRequest),
  );
}
export function batchGetFeedbackRequestFromJSON(
  jsonString: string,
): SafeParseResult<BatchGetFeedbackRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => BatchGetFeedbackRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'BatchGetFeedbackRequest' from JSON`,
  );
}
